const faqs = [
  {
    id: 1,
    heading: "Commercial & Public Buildings",
    content: [
      // {
      //   imageUrl: "publicbuilding/public (1).png",
      //   heading: "Airports",
      //   href: "/commercial#Airports",
      // },
      // {
      //   imageUrl: "publicbuilding/public (2).png",
      //   heading: "Hospitals & IVF Centres",
      //   href: "/commercial#Hospitals",
      // },
      {
        imageUrl: "publicbuilding/public (8).png",
        heading: "Shopping malls",
        href: "/commercial#Halls",
      },
      {
        imageUrl: "publicbuilding/public (7).png",
        heading: "Hotels",
        href: "/commercial#Hotels",
      },
      {
        imageUrl: "publicbuilding/public (3).png",
        heading: "Museums",
        href: "/commercial#Museums",
      },
      {
        imageUrl: "publicbuilding/public (6).png",
        heading: "Offices",
        href: "/commercial#Offices",
      },
      {
        imageUrl: "publicbuilding/public (5).png",
        heading: "Restaurants",
        href: "/commercial#Restaurants",
      },
      {
        imageUrl: "publicbuilding/public (4).png",
        heading: "Schools & Universities",
        href: "/commercial#Schools",
      },


    ],
  },
  {
    id: 2,
    heading: "Industrial/Transportation",
    content: [
      {
        imageUrl: "industrail/industry (1).png",
        heading: "Airport",
        href: "/industrial#Airport",
      },
      {
        imageUrl: "industrail/industry (5).png",
        heading: "Power Generation",
        href: "/industrial#Power",
      },
      {
        imageUrl: "industrail/industry (4).png",
        heading: "Public Transportations",
        href: "/industrial#Public",
      },
      {
        imageUrl: "industrail/industry (3).png",
        heading: "Refineries",
        href: "/industrial#Refineries",
      },
      // {
      //   imageUrl: "industrail/industry (2).png",
      //   heading: "Pulp & Paper",
      //   href: "/industrial#Pulp",
      // },
    ],
  },
  {
    id: 3,
    heading: "Food and Beverage",
    content: [
      {
        imageUrl: "food/food (1).png",
        heading: "Beverage Production",
        href: "/food#Beverage",
      },
      {
        imageUrl: "food/food (3).png",
        heading: "Dairy Processes",
        href: "/food#Dairy",
      },
      {
        imageUrl: "food/food (2).png",
        heading: "Food Processing",
        href: "/food#Food",
      },
    ],
  },
  {
    id: 4,
    heading: "Material Processing",
    content: [
      {
        imageUrl: "material/material (1).png",
        heading: "Mining",
        href: "/material#Mining",
      },
      {
        imageUrl: "material/material (2).png",
        heading: "Oil, Gas & Chemicals",
        href: "/material#Oil",
      },
      {
        imageUrl: "material/material (3).png",
        heading: "Pulp & Paper",
        href: "/material#Pulp",
      },
    ],
  },
  {
    id: 5,
    heading: "Water/Waste",
    content: [
      {
        imageUrl: "waste/waste (1).png",
        heading: "Corrosion Control",
        href: "/waste#Corrosion",
      },
      {
        imageUrl: "waste/waste (2).png",
        heading: "Odor Control",
        href: "/Waste#Odor",
      },
      {
        imageUrl: "waste/waste (3).png",
        heading: "Emergency Gas Scrubbing",
        href: "/Waste#Emergency",
      },
    ],
  },
];

export default faqs;



export const market = [{
  id: 1,
  heading: "Commerical & Public Buildings",
  imageUrl: "market/m (1).png",
  href: "/commercial",
},
{
  id: 2,
  heading: "Food & Beverages",
  imageUrl: "market/m (2).png",
  href: "/Industrial",
},
{
  id: 3,
  heading: "Material Processing",
  imageUrl: "market/m (3).png",
  href: "/Food",
},
{
  id: 4,
  heading: "Waste/Water",
  imageUrl: "market/m (4).png",
  href: "/Material",
},
{
  id: 5,
  heading: "Industrial / Transportation",
  imageUrl: "market/m (5).png",
  href: "/Waste",
},
]